import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import AboutUs from './components/AboutUs'; 
import RiskManagement from "./components/RiskManagement";
import EnergyEfficiency from "./components/EnergyEfficiency";
import UrbanResilience from "./components/UrbanResilience";
import SustainableConstruction from "./components/SustainableConstruction";
import EconomicsAndManagement from "./components/EconomicsAndManagement";
import Resources from './components/Resources';

function App() {
  return (
    <div className="App">
      <Router>
        <Navbar />

        {/* MAIN CONTENT WRAPPER */}
        <div className="page-wrapper">

          <Routes>
            <Route 
              path="/" 
              element={
                <div className="home-page">
                  <img
                    src="/images/globe.png"
                    alt="Background"
                    className="background-image"
                  />
                </div>
              }
            />

            <Route path="/aboutus" element={<AboutUs />} />
            <Route path="/resources" element={<Resources />} />

            <Route path="/learning-materials/risk-management" element={<RiskManagement />} />
            <Route path="/learning-materials/energy-efficiency" element={<EnergyEfficiency />} />
            <Route path="/learning-materials/urban-resilience" element={<UrbanResilience />} />
            <Route path="/learning-materials/sustainable-construction" element={<SustainableConstruction />} />
            <Route path="/learning-materials/economics-and-management" element={<EconomicsAndManagement />} />

          </Routes>
        </div>

        <Footer />
      </Router>
    </div>
  );
}

export default App;
